import { dashboardActionTypes } from './actionsTypes';

const createCopy = obj => Object.assign({}, obj);
const createDeepCopy = obj => JSON.parse(JSON.stringify(obj));
const updateObject = (obj, data) => {
  const initObj = createCopy(obj);

  function isObj(value) {
    return value !== null && typeof value === 'object' && !value.length;
  }

  function update(objectClone, updateData) {
    for (const updateKey in updateData) {
      if (objectClone[updateKey]) {
        if (isObj(updateData[updateKey])) {
          update(objectClone[updateKey], updateData[updateKey]);
        } else {
          objectClone[updateKey] = updateData[updateKey];
        }
      } else {
        objectClone[updateKey] = updateData[updateKey];
      }
    }
  }
  update(initObj, data);

  return initObj;
};

const initialState = {
  appointments: {
    list: null,
    upcoming: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case dashboardActionTypes.SET_UPCOMING_APPOINTMENTS: {
      const tState = createDeepCopy(state);
      tState.appointments.upcoming = action.payload;
      return tState;
    }
    case dashboardActionTypes.SET_APPOINTMENTS: {
      const tState = createDeepCopy(state);
      tState.appointments.list = action.payload;
      return tState;
    }
    case dashboardActionTypes.UPDATE_SINGLE_APPOINTMENT: {
      const st = createDeepCopy(state);
      const {
        appointments: { upcoming }
      } = st;
      const objIndex =
        st.appointments &&
        st.appointments.list &&
        st.appointments.list.findIndex(obj => obj.id === action.payload.id);
      const upcomingObjIndex =
        upcoming &&
        upcoming.appointments &&
        upcoming.appointments.findIndex(obj => obj.id === action.payload.id);

      // update only appointments
      if (typeof objIndex === 'number' && objIndex > -1) {
        st.appointments.list[objIndex] = updateObject(
          st.appointments.list[objIndex],
          action.payload.updateParams
        );
      } else if (Array.isArray(st.appointments.list)) {
        st.appointments.list.push(action.payload.updateParams);
      }
      // update upcoming appointments
      if (typeof upcomingObjIndex === 'number' && upcomingObjIndex > -1) {
        st.appointments.upcoming.appointments[upcomingObjIndex] = updateObject(
          upcoming.appointments[upcomingObjIndex],
          action.payload.updateParams
        );
      }

      return {
        ...state,
        appointments: st.appointments,
        upcoming: st.upcoming
      };
    }
    default:
      return state;
  }
};
